import { createSlice } from '@reduxjs/toolkit'
import { get, noop } from 'lodash'

import api from 'common/api'

export const getProfile = () => api.get(`/api/student/profile/combined/source_info`)

const appProfileDomain = createSlice({
  name: 'appProfile',
  initialState: {},
  reducers: {
    setAppProfile(state, action) {
      state.record = action.payload
      return state
    },
  },
})

export const selectAppProfile = (state) => get(state, 'appProfile.record')
export const { setAppProfile } = appProfileDomain.actions

export const fetchAppProfile = () => (dispatch) =>
  getProfile()
    .catch(noop)
    .then((res) => dispatch(setAppProfile({ ...res })))
export default appProfileDomain.reducer
